module.exports = __webpack_public_path__ + "img/qft-dagger.9cfb57ef.svg";